// under the hood enums are numbers
export enum KeyState {
    Unused,
    Incorrect,
    Correct,
    WrongSpot
}

// export class Key {
//     // these are properties stored in a class
//     letter: string
//     state: KeyState

//     // constructor initializes everything
//     constructor(letter: string) {
//         // this refers to current object
//         this.letter = letter
//         this.state = KeyState.Unused
//     }

//     // This is just an example of an instance method (function)
//     // copyKey(key: Key) {
//     //     const letter = "f"
//     //     this.letter = key.letter
//     //     this.state = key.state
//     // }
// }

export class KeyboardManager {
    keys: Map<string, KeyState>

    constructor() {
        const validLetters = ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P", "A", "S", "D", "F", "G", "H", "J", "K", "L", "Z", "X", "C", "V", "B", "N", "M"]
        this.keys = new Map<string, KeyState>();
        validLetters.map(letter => {
            this.keys.set(letter, KeyState.Unused)
        });
    }

    setKeyState(letter: string, newState: KeyState) {
        let keyState = this.keys.get(letter);
        // keyState gives enum KeyState back
        // need to check for undefined because keyState needs to not be 0 (reference enums)
        // if keyState is 0 it means the same as "false"
        if (keyState !== undefined) {
            keyState = newState;
            this.keys.set(letter, keyState);
        } else {
            console.log("Got a key that wasn't in the keyboard", letter);
            return KeyState.Unused;
            // throw new Error("Got a key that wasn't in the keyboard");
        }
    }

    getKeyState(letter: string): KeyState {
        const keyState = this.keys.get(letter);
        if (keyState !== undefined) {
            return keyState;
        } else {
            console.log("Got a key that wasn't in the valid letter list", letter)
            return KeyState.Unused;
            // throw new Error("Got a key that wasn't in the keyboard");
        }
    }

    copyKeyboard(keyboard: KeyboardManager) {
        this.keys.forEach((keyState, letter) => {
            keyboard.setKeyState(letter, keyState);
        })
    }
}
